import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import dateUtils from '@utils/date.utils';
import { useRoute } from 'vue-router';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import cookieUtils from '@utils/cookie.utils';
import baseConfig from '@config/base.config';
import { ref } from 'vue';

export interface HomeMetricsQueryInput {
    startTime: string;
    endTime: string;
    profileId: string;
}

export type RangeType = 'URL' | 'MERGE_URL' | 'PAGE_GROUP' | 'SITE';

export interface OriginUrlInput {
    sid: string;
    rangeType: RangeType;
}

const QUERY = gql`
    query getHomeBaseMetrics($input: HomeMetricsQueryInput!) {
        getHomeBaseMetrics(input: $input) {
            user
            session
            pv
        }
    }
`;

const QUERY_PTI_ORIGIN_URL = gql`
    query getPtiOriginUrl($input: OriginUrlInput!) {
        getPtiOriginUrl(input: $input)
    }
`;

const baseData: any = ref([]);
const loading = ref(false);
export function useBaseData() {
    const route = useRoute();
    const { profileInfo } = useProfileInfo();

    const getBaseData = function (
        params?: {
            profileId?: string;
            timeZone?: string;
            startTime?: string;
            endTime?: string;
        },
        resolveCallback?: () => void,
        rejectCallback?: () => void
    ) {
        const startTime = dateUtils.getMomentTime({
            num: 0,
            type: 'day',
            isStart: true,
            timezone: params?.timeZone || profileInfo.value?.timeZone
        } as any);
        const endTime = startTime;
        loading.value = true;
        const { onError, onResult } = useQuery<{
            getHomeBaseMetrics: HomeMetricsQueryInput;
        }>(
            QUERY,
            {
                input: {
                    profileId:
                        params?.profileId ||
                        route.params?.sid ||
                        cookieUtils.getItem(baseConfig.LAST_PROFILE_ID),
                    startTime: params?.startTime || startTime,
                    endTime: params?.endTime || endTime
                }
            },
            {
                fetchPolicy: 'cache-and-network'
            }
        );

        onResult(data => {
            if (data?.data?.getHomeBaseMetrics) {
                baseData.value = data?.data?.getHomeBaseMetrics;
                resolveCallback && typeof resolveCallback === 'function' && resolveCallback();
                loading.value = false;
            }
        });
        onError(err => {
            rejectCallback && typeof rejectCallback === 'function' && rejectCallback();
            loading.value = false;
        });
    };

    return {
        loading,
        baseData,
        getBaseData
    };
}

export const getPtiOriginUrl = function (
    params: OriginUrlInput,
    resolveCallback?: (res: any) => void,
    rejectCallback?: () => void
) {
    const { onError, onResult } = useQuery(
        QUERY_PTI_ORIGIN_URL,
        { input: params },
        {
            fetchPolicy: 'no-cache'
        }
    );

    onResult(data => {
        if (data?.data?.getPtiOriginUrl) {
            resolveCallback &&
                typeof resolveCallback === 'function' &&
                resolveCallback(data?.data?.getPtiOriginUrl);
        }
    });
    onError(err => {
        console.log(err);
        rejectCallback && typeof rejectCallback === 'function' && rejectCallback();
    });
};
